// Miroir de api/report_maker/rating.py::rate_to_letter — mêmes seuils, sur
// une échelle 0-5. letterToRate() renvoie le milieu de la tranche, pour un
// aller-retour lettre -> valeur -> lettre déterministe.
const RATE_BANDS = [
    { letter: 'A', min: 4.3, max: 5 },
    { letter: 'B', min: 3.6, max: 4.3 },
    { letter: 'C', min: 2.9, max: 3.6 },
    { letter: 'D', min: 2.2, max: 2.9 },
    { letter: 'E', min: 1.5, max: 2.2 },
    { letter: 'F', min: 0.8, max: 1.5 },
    { letter: 'G', min: 0, max: 0.8 },
];

export const rateToLetter = (rate) => {
    if (rate === null || rate === undefined || Number.isNaN(rate)) return null;
    const band = RATE_BANDS.find((b) => rate >= b.min) || RATE_BANDS[RATE_BANDS.length - 1];
    return band.letter;
};

export const letterToRate = (letter) => {
    const band = RATE_BANDS.find((b) => b.letter === letter);
    return band ? (band.min + band.max) / 2 : null;
};

export const RATING_LETTERS = RATE_BANDS.map((b) => b.letter);
